import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from '../components/common/PageLayout';
import courseData from '../data/course.json';
import './Offerings.css';

const Offerings = () => {
  const navigate = useNavigate();
  const offerings = courseData.offerings || [];

  const handleClick = (offering) => {
    if (offering.type === 'direct') {
      navigate(`/course/${offering.courseSlug}`);
    } else {
      navigate(`/offerings/${offering.id}`);
    }
  };

  return (
    <PageLayout>
      <section className="page-hero">
        <h1>Our Offerings</h1>
        <p>Choose a learning path—direct courses or category tracks with multiple specializations.</p>
      </section>
      <section className="offerings-section">
        <div className="offerings-grid">
          {offerings.map((offering) => (
            <button
              key={offering.id}
              type="button"
              className="offering-card"
              onClick={() => handleClick(offering)}
            >
              <div className="offering-card-image-wrap">
                <img src={offering.imageUrl} alt="" loading="lazy" />
              </div>
              <div className="offering-card-body">
                <h3 className="offering-card-title">{offering.title}</h3>
                <p className="offering-card-description">{offering.description}</p>
                <span className="offering-card-cta">
                  {offering.type === 'direct' ? 'View course' : 'View options'}
                </span>
              </div>
            </button>
          ))}
        </div>
      </section>
    </PageLayout>
  );
};

export default Offerings;
